<template>
  <section>
    <!-- Search -->
    <article class="search-container">
      <h1 class="forza-bold">Introducing Snapsheets</h1>
      <p class="mb-4 slate-bold">
        Snap Sheets are personalized sales sheets that get rid of design
        headaches and allow you to focus on selling. Start by using any of our
        pre-assembled templates below or customize one to meet your customer's
        specific needs.
      </p>

      <!-- Checkbox Show Archived Projects -->
      <div class="sort-by row mt-4">
        <div
          class="flex mt-3 mt-sm-0"
          v-for="(filterKey, i) in filters"
          :key="i + '-template-filter'"
        >
          <label
            class="filter"
            :class="{ checked: filterKey === activeFilter }"
          >
            <input
              type="radio"
              :checked="filterKey === activeFilter"
              @change="emitToggleActiveFilter(filterKey)"
            />
            <span></span>
            <p>{{ filterKey }}</p>
          </label>
        </div>
      </div>

      <!-- Search bar -->
      <label for="search-templates" id="search-templates-label">
        <!-- <img
          src="https://res.cloudinary.com/dpww52vcx/image/upload/v1626211547/lupa_akweyg.png"
          alt="search icon"
        /> -->
        <input
          id="search-templates"
          name="search-templates"
          type="text"
          placeholder='Ex. "Pink Apparel" or "Outerwear Collection" or "Back 2 School"'
          @input="$emit('search-input-change', $event.target.value)"
        />
      </label>
    </article>

    <!-- Video -->
    <article class="video-container">
      <iframe
        width="380"
        height="200"
        src="https://www.youtube.com/embed/wDooew5YJYI"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <div class="video-container-text-container">
        <div class="watch-how-it-works">
          <img
            src="@/assets/snapsheet-templates/arrow-ss-templates.png"
            alt="arrow"
          />
          <p>Watch how it works!</p>
        </div>

        <p>
          New to Snap Sheets? Watch this tutorial to learn how you can build and
          customize these sales sheets to fit your exact needs. Customization
          features include customer logo upload, custom dealer pricing,
          adjustable product colorways, and more. To top it off, Snap Sheets are
          free and come with your company's branding and contact info displayed.
        </p>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: "SnapsheetsTemplatesHeader",
  props: ["filters", "activeFilter"],

  methods: {
    emitToggleActiveFilter(checkboxKey) {
      this.$emit("toggleActiveFilter", checkboxKey);
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  /* border-bottom: 4px solid rgb(180, 180, 180); */
  display: flex;
  gap: 3rem;
  justify-content: space-between;
  padding: 2rem 0;
  margin-bottom: 1rem;
  .search-container {
    width: 45%;
    h1 {
      text-transform: uppercase;
      margin-bottom: 1.5rem;
    }

    label#search-templates-label {
      /* box-shadow: 0 0 5px -1px #0000005e; */
      border: 1px solid $placeholder;
      border-radius: 5px;
      display: flex;
      align-items: center;
      padding: 0.5rem 1rem;
      width: 100%;
      transition: box-shadow 0.2s;

      img {
        margin-right: 1rem;
      }

      input {
        flex: 1 1;
        border: none;
        outline: none;
        font-size: 1.2rem;
      }
    }

    .sort-by {
      margin-bottom: 1rem;

      .filter {
        text-align: center;
        border-radius: 6px;
        padding: 0.5rem 1rem;
        margin-right: 0.5rem;
        cursor: pointer;
        transition: background-color 0.2s;
        &:hover {
          background-color: #f5f5f5;
        }
        &.checked {
          background: $grey-light;
          cursor: initial;
        }
        input {
          display: none;
        }
        p {
          text-transform: capitalize;
          margin: 0 !important;
        }
      }
    }
  }

  .video-container {
    gap: 2rem;
    display: flex;
    width: 45%;
    .watch-how-it-works {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      img {
        max-width: 100%;
        height: 35px;
      }
      p {
        font-family: "ForzaBold" !important;
        text-transform: uppercase;
        margin: 0;
        text-align: center;
        margin: auto;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    flex-flow: column;

    .search-container,
    .video-container {
      width: 100%;
    }
  }
  @media screen and (max-width: 576px) {
    .video-container {
      flex-flow: column;
    }
  }
}
</style>